import { AuthGuard } from '$synapse/core';
import { Route } from '@angular/router';
import { Roles } from '$synapse/models';
import { CandidatesResolver } from './candidates-resolver';
import { CandidatesComponent } from './candidates.component';

export const CANDIDATES_ROUTES: Route[] = [
  {
    path: 'candidates',
    component: CandidatesComponent,
    canActivate: [AuthGuard],
    resolve: {
      candidates: CandidatesResolver,
    },
    data: { roles: [Roles.MANAGER] },
    runGuardsAndResolvers: 'always',
  },
];
